import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import PageContainer from '../common/PageContainer';
import { PageWrapper, Title } from '../elements';

import {
  SmallText,
  SwitchWrapper,
  ToggleWrapper,
  ToggleSwitch,
} from './elements';
import { useText } from 'common/hooks';

const deps = {
  settingsForm: state.account.settingsForm,
  isSavingSettings: state.account.isSavingSettings,
  challengeEmailSettingChanged: sequences`account.challengeEmailSettingChanged`,
};

export function Emails({
  settingsForm,
  isSavingSettings,
  challengeEmailSettingChanged,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <PageContainer tab={'emails'}>
      <PageWrapper>
        <Title as={'h2'}>
          {t('account.settings.emails.email_preferences')}
        </Title>
        <SwitchWrapper>
          <SmallText>
            {t('account.settings.emails.receive_challenge_emails')}
          </SmallText>
          <ToggleWrapper>
            <ToggleSwitch
              disabled={isSavingSettings}
              checked={settingsForm.sendChallengeEmail.value}
              onChange={() =>
                challengeEmailSettingChanged({
                  value: !settingsForm.sendChallengeEmail.value,
                })
              }
            />
          </ToggleWrapper>
        </SwitchWrapper>
      </PageWrapper>
    </PageContainer>
  );
}

export default connect(deps, Emails);
